import React from 'react';


const CustomCard = ({ total, label = 'Total Customers', icon }) => (

    <div className='card'>
        <div className='card-body'>
            <div className='media align-items-center'>
                <div className='media-body'>
                    <h3>{total}</h3>
                    <span className='fs-14 text-black'>{label}</span>
                </div>
                <span className='bg-primary custom-card-icon'>
                    {icon}
                </span>
            </div>
        </div>
    </div>
);

export default CustomCard;
